(function($) {
 $('.single-shop .slider').slick({
    // centerMode: true,
    // slidesToShow: 1,
    // centerPadding: '10px',
    autoplay: true,
    // autoplaySpeed: 2000,
    // variableWidth: true,
    // arrows: true,
    dots: true
    // prevArrow: '.slider-prev',
    // nextArrow: '.slider-next',
  });
})(jQuery);
